import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { GridOptions, ColDef, GridApi } from 'ag-grid';
export class MgridComponent implements OnInit {
  gridOptions: GridOptions = {};
  columnDefs: Array<ColDef>;

   theme;
   data;
   options;
   columnDefinitions;

  griApi: GridApi;
  rowData: Array<Object>;
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
    this.rowData = [...this.data];
    this.gridOptions = {
      rowSelection: true,
      ...this.options
    };

    // Check if column defs are provided
    if (this.columnDefinitions === undefined) {
      this.columnDefs = this.getColumnDefs(this.data[0]);
    } else {
      this.columnDefs = [...this.columnDefinitions];
    }
  }
/**
 * @param {?} firstRowData
 * @return {?}
 */
private getColumnDefs(firstRowData: any) {
    return Object.keys(firstRowData).map((key) => {
      return {
        headerName: key[0].toUpperCase() + key.substring(1),
        field: key,
        width: 100,
      };
    });

  }
/**
 * @param {?} params
 * @return {?}
 */
onGridReady(params) {
    this.griApi = params.api;
    params.api.sizeColumnsToFit();
    params.api.refreshCells();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-mgrid',
  template: `
    <ag-grid-angular
    style="height: 100%"
    [class]="theme"
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefs"
    [rowData]="data"
    enableCellChangeFlash
    (gridReady)="onGridReady($event)"
    >
    </ag-grid-angular>`
  ,
  styles: [`
    @import url(C:\\Projects\\m-grid\\node_modules\\ag-grid\\dist\\styles\\ag-grid.css);
    @import url(C:\\Projects\\m-grid\\node_modules\\ag-grid\\dist\\styles\\ag-theme-fresh.css);
    .ag-header .ag-pivot-off .ag-theme-mprest {
      background-color: orange;
      border-color: #FF0000; }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'theme': [{ type: Input },],
'data': [{ type: Input },],
'options': [{ type: Input },],
'columnDefinitions': [{ type: Input },],
};
}

function MgridComponent_tsickle_Closure_declarations() {
/** @type {?} */
MgridComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MgridComponent.ctorParameters;
/** @type {?} */
MgridComponent.propDecorators;
/** @type {?} */
MgridComponent.prototype.gridOptions;
/** @type {?} */
MgridComponent.prototype.columnDefs;
/** @type {?} */
MgridComponent.prototype.theme;
/** @type {?} */
MgridComponent.prototype.data;
/** @type {?} */
MgridComponent.prototype.options;
/** @type {?} */
MgridComponent.prototype.columnDefinitions;
/** @type {?} */
MgridComponent.prototype.griApi;
/** @type {?} */
MgridComponent.prototype.rowData;
}








interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
